import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import { MatPaginator } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import { ModalDismissReasons, NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { Observable, Subject } from 'rxjs';
import { DataService } from 'src/app/services/data.service';
import { UserUtilityService } from 'src/app/services/user-utility.service';
import { IceapiService, IdmApiService } from '../../../../../services/index';
import { FlangeMaterialModel } from '../../../models/index';
import { Router } from '@angular/router';
import { JointCalcService } from 'src/app/Modules/idms/components/plant-manager/services/joint-calc-service.service';
import { takeUntil } from 'rxjs/operators';
import { CalculationType } from '../../../enums/calculation-type.enum';

export interface ControlData {
    controlId: string;
    label: string;
}
@Component({
    selector: 'app-flange-material',
    templateUrl: './flange-material.component.html',
    styleUrls: ['./flange-material.component.scss'],
    standalone: false
})
export class FlangeMaterialComponent implements OnInit {
    @Input() events: Observable<void>;
    @Input() form: UntypedFormGroup;
    @Input() enable: boolean;
    @Input()
    set controlId(value: string) {
        this._controlId = value;
    }
    get controlId(): string {
        return this._controlId ?? 'flangeMaterial';
    }

    @Input()
    set controlLabel(value: string) {
        this._controlLabel = value;
    }
    get controlLabel(): string {
        return this._controlLabel ?? 'Flange Material';
    }

    @Input()
    set standardId(value: string) {
        if (value) {
            this._standardId = value;
            if (!this.jointCalcService.isPipeCode) this.getFlangeMaterials();
        }
    }
    get standardId(): string {
        return this._standardId;
    }

    @Input()
    set isCustom(value: boolean) {
        if (value) {
            this._isCustom = value;
            if (!this.jointCalcService.isPipeCode) this.getFlangeMaterials();
        }
    }
    get isCustom(): boolean {
        return this._isCustom;
    }

    @Input()
    set isEngineeredJoint(value: boolean) {
        this._isEngineeredJoint = value;
        if (value) {
            if (!this.jointCalcService.isPipeCode) this.getFlangeMaterials();
        }
    }
    get isEngineeredJoint(): boolean {
        return this._isEngineeredJoint;
    }

    @Input()
    set doFlangeMaterialReset(value: boolean) {
        if (value) {
            this.selectedValue = '';
        }
    }
    @ViewChild(MatPaginator) paginator: MatPaginator;
    @Output() selected: EventEmitter<FlangeMaterialModel> = new EventEmitter();
    destroy$ = new Subject();

    tooltip_position = 'above';
    selectedValue: string;
    selectedRow: FlangeMaterialModel;
    public filterlist: FlangeMaterialModel[];
    public pageSize = 5;
    public currentPage = 0;
    public totalSize = 0;
    public searchFilterList: FlangeMaterialModel[];
    searchText = new UntypedFormControl('', []);
    closeResult: string;
    displayedColumns: string[] = [];
    optionList: MatTableDataSource<FlangeMaterialModel> | FlangeMaterialModel[];
    optionListCopy: FlangeMaterialModel[];

    private flangeModalRef: NgbModalRef;
    private _controlId: string;
    private _controlLabel: string;
    private _standardId: string;
    private _isCustom: boolean = false;
    private _isEngineeredJoint: boolean = false;
    constructor(
        private iceapi: IceapiService,
        private modalService: NgbModal,
        private dataService: DataService,
        private user_utility: UserUtilityService,
        private router: Router,
        private jointCalcService: JointCalcService,
        private idmApi: IdmApiService
    ) {}

    ngOnInit(): void {
        this.form.markAllAsTouched();

        this.updateDisplayedColumns();

        if ((this.router.url == '/idms/plantmanager' || this.router.url.includes('/idms/plantmanagerView')) && this.jointCalcService.isPipeCode) {
            this.pipespecwithMaterial();
        }

        this.form
            .get(this.controlId)
            .valueChanges.pipe(takeUntil(this.destroy$))
            .subscribe((value) => {
                if (value)
                    if ((this.router.url == '/idms/plantmanager' || this.router.url.includes('/idms/plantmanagerView')) && this.jointCalcService.isPipeCode) {
                        this.jointCalcService.selectedflangeMaterial.next(value);
                    }
            });
    }

    updateDisplayedColumns(): void {
        if (this.router.url === '/idms/plantmanager') {
            this.displayedColumns = ['id', 'alias', 'position', 'type', 'design', 'composition', 'class'];
        } else {
            this.displayedColumns = ['id', 'position', 'type', 'design', 'composition', 'class'];
        }
    }

    async getFlangeMaterials() {
        this.searchText.reset('');
        if (!this.isEngineeredJoint) {
            if (!this.standardId && !this.isCustom) return;
        }

        let flangeMaterials = await this.apiCallLoadFlangeMaterials();

        if (flangeMaterials.success === true) {
            this.optionListCopy = flangeMaterials.response;
            this.filterlist = flangeMaterials.response;
            this.optionList = new MatTableDataSource(flangeMaterials.response);
            this.optionList.paginator = this.paginator;
            this.totalSize = this.filterlist.length;
            this.iterator(this.filterlist);
            this.dataService.flangeMaterialList = flangeMaterials.response;
            if (flangeMaterials.response.find((x) => x.flangeMaterialId == this.form.get(this.controlId).value))
                this.selectedValue = flangeMaterials.response.find((x) => x.flangeMaterialId == this.form.get(this.controlId).value)?.qualifiedName;
            this.dataService.selectedFlangeMaterialObject = flangeMaterials.response.find((x) => x.flangeMaterialId == this.form.get(this.controlId).value);

            //If there is only one row.
            if (this.optionListCopy.length === 1) {
                this.selectedValue =
                    `${this.optionListCopy[0].flangeMaterialSpecNo.specNo}  ${this.optionListCopy[0].typeGrade}  ${this.optionListCopy[0].alloyDesignUnsno}  ${this.optionListCopy[0].nominalComposition}  ${this.optionListCopy[0].classCondTemper}`.replace(
                        /undefined/g,
                        ' '
                    );
                this.form.get(this.controlId).setValue(this.optionListCopy[0].flangeMaterialId);
            }
            
               if(this.dataService.selectedFlangeMaterialObject && this.dataService.selectedFlangeMaterialObject?.alias?.materialAliasId &&  this.controlId !='flangeMaterial2')
                { 
                    this.dataService.flangeMaterialAliasId1=this.dataService.selectedFlangeMaterialObject?.alias?.materialAliasId;
                    this.form.get('flangeMaterialAliasId1')?.setValue(this.dataService.selectedFlangeMaterialObject?.alias?.materialAliasId); 
                }

                if(this.dataService.selectedFlangeMaterialObject && this.dataService.selectedFlangeMaterialObject?.alias?.materialAliasId && this.controlId=='flangeMaterial2')
                { 
                    this.dataService.flangeMaterialAliasId2=this.dataService.selectedFlangeMaterialObject?.alias?.materialAliasId;
                    this.form.get('flangeMaterialAliasId2')?.setValue(this.dataService.selectedFlangeMaterialObject?.alias?.materialAliasId); 
                }

        }  
    }

    async apiCallLoadFlangeMaterials() {
        if (this.router.url != '/idms/plantmanager') {
            return await this.iceapi.getFlangeMaterials(this.standardId, this.isCustom).toPromise();
        } else {
            return await this.idmApi.getCalcFlangeMaterials(this.standardId, this.isCustom).toPromise();
        }
    }

    public handlePage(e: any) {
        this.currentPage = e.pageIndex;
        this.pageSize = e.pageSize;
        if (this.searchText.value) {
            this.iterator(this.searchFilterList);
        } else {
            this.iterator(this.filterlist);
        }
    }

    private iterator(array: any) {
        const end = (this.currentPage + 1) * this.pageSize;
        const start = this.currentPage * this.pageSize;
        const part = array.slice(start, end);
        this.optionList = part;
    }

    applyFilter($event: any) {
        let filterData = $event.target.value;
        this.searchFilterList = [];
        this.searchFilterList = this.optionListCopy.filter((item) => {
            return (
                (item.flangeMaterialSpecNo.specNo !== undefined ? item.flangeMaterialSpecNo.specNo : '')
                    .toLowerCase()
                    .trim()
                    .includes(filterData.toLowerCase().trim()) ||
                (item.typeGrade !== undefined ? item.typeGrade : '').toLowerCase().trim().includes(filterData.toLowerCase().trim()) ||
                (item.alloyDesignUnsno !== undefined ? item.alloyDesignUnsno : '').toLowerCase().trim().includes(filterData.toLowerCase().trim()) ||
                (item.nominalComposition !== undefined ? item.nominalComposition : '').toLowerCase().trim().includes(filterData.toLowerCase().trim()) ||
                (item.classCondTemper !== undefined ? item.classCondTemper : '').toLowerCase().trim().includes(filterData.toLowerCase().trim())
            );
        });
        this.currentPage = 0;
        this.totalSize = this.searchFilterList.length;
        this.iterator(this.searchFilterList);
        if ($event.key === 'Backspace') {
            this.optionListCopy = this.filterlist;
            this.searchFilterList = [];
        }
    }

    open(content) {
        this.flangeModalRef = this.modalService.open(content, {
            ariaLabelledBy: 'modal-basic-title',
            backdrop: 'static',
            keyboard: false,
            size: 'xl',
        });
        this.searchText.reset('');
        this.optionList = new MatTableDataSource(this.filterlist);
        this.optionList.paginator = this.paginator;
        this.totalSize = this.filterlist.length;
        this.currentPage = 0;
        this.iterator(this.filterlist);
        this.flangeModalRef.result.then(
            (result) => {
                this.searchText.reset('');
                this.closeResult = `Closed with: ${result}`;
            },
            (reason) => {
                this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
            }
        );
    }

    private getDismissReason(reason: any): string {
        if (reason === ModalDismissReasons.ESC) {
            return 'by pressing ESC';
        } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
            return 'by clicking on a backdrop';
        } else {
            return `with: ${reason}`;
        }
    }

    selectItem(row: FlangeMaterialModel) {
        this.selectedRow = row;
        this.selectedValue =
            `${row.flangeMaterialSpecNo.specNo}  ${row.typeGrade}  ${row.alloyDesignUnsno}  ${row.nominalComposition}  ${row.classCondTemper}`.replace(
                /undefined/g,
                ' '
            );
        this.form.get(this.controlId).setValue(row.flangeMaterialId);
        // this.modalService.dismissAll()
        // this.ngbActiveModal.close();
        if (this.flangeModalRef) {
            this.flangeModalRef.close();
        }
        this.selected.emit(this.selectedRow);
        this.dataService.selectedFlangeMaterial = this.selectedRow.qualifiedName;
        this.dataService.selectedFlangeMaterialObject = row;
        if(row?.alias?.materialAliasId && this.controlId=='flangeMaterial1')
        {
            this.dataService.flangeMaterialAliasId1 = row.alias.materialAliasId;    
             this.form.get('flangeMaterialAliasId1')?.setValue(row.alias.materialAliasId);         
        }
       else if(row?.alias?.materialAliasId && this.controlId=='flangeMaterial2')
        {
            this.dataService.flangeMaterialAliasId2 = row.alias.materialAliasId;    
            this.form.get('flangeMaterialAliasId2')?.setValue(row.alias.materialAliasId);         
        }
        else if(row?.alias?.materialAliasId)
        {
             this.dataService.flangeMaterialAliasId1 = row.alias.materialAliasId;    
             this.form.get('flangeMaterialAliasId1')?.setValue(row.alias.materialAliasId);

        }
       
        
   
    }

    async pipespecwithMaterial() {
        let controlValue = this.form.get(this.controlId).value;
        this.jointCalcService.selectedflangeFacingType.pipe(takeUntil(this.destroy$)).subscribe(async (ft) => {
            if (ft && this.jointCalcService.pipeSpecpayload.lookupParams.calculationType == CalculationType.StandardFlange) {
                this.jointCalcService.pipeSpecpayload.lookupParams.recordId.flangeFacingTypeId = ft;

                let InputGroup = this.jointCalcService.pipeSpecpayload.lookupParams;
                InputGroup.recordId.flangeFacingTypeId = ft;

                InputGroup.recordId.gasketId =
                    InputGroup.others.boltType =
                    InputGroup.recordId.boltMaterialId =
                    InputGroup.others.tighteningSpecification =
                        null;

                let pipeSpecFlangeMaterial = await this.idmApi.getCalcFlangeMaterials(this.standardId, this.isCustom).toPromise();

                if (pipeSpecFlangeMaterial.success) {
                    this.optionListCopy = pipeSpecFlangeMaterial.response;

                    this.optionListCopy = await this.jointCalcService.managePayloadForRecourdId('flangeMaterialId', pipeSpecFlangeMaterial.response);
                    this.filterlist = this.optionListCopy.slice();

                    this.optionList = new MatTableDataSource(this.optionListCopy.slice());
                    this.optionList.paginator = this.paginator;
                    this.totalSize = this.filterlist.length;
                    this.iterator(this.filterlist);
                    this.dataService.flangeMaterialList = this.optionListCopy.slice();
                    if (pipeSpecFlangeMaterial.response.find((x) => x.flangeMaterialId == controlValue))
                        this.selectedValue = pipeSpecFlangeMaterial.response.find((x) => x.flangeMaterialId == controlValue)?.qualifiedName;
                    this.dataService.selectedFlangeMaterialObject = this.optionListCopy.slice().find((x) => x.flangeMaterialId == controlValue);
                    //If there is only one row.
                    if (this.optionListCopy.length === 1) {
                        this.selectedValue =
                            `${this.optionListCopy[0].flangeMaterialSpecNo.specNo}  ${this.optionListCopy[0].typeGrade}  ${this.optionListCopy[0].alloyDesignUnsno}  ${this.optionListCopy[0].nominalComposition}  ${this.optionListCopy[0].classCondTemper}`.replace(
                                /undefined/g,
                                ' '
                            );
                        {
                            this.form.get(this.controlId).setValue(this.optionListCopy[0].flangeMaterialId);
                        }
                    } else if (this.dataService.calculationData?.input?.recordId?.flangeMaterialId1) {
                        this.form.get(this.controlId).setValue(this.dataService.calculationData?.input?.recordId?.flangeMaterialId1);
                    }
                } else if (pipeSpecFlangeMaterial.isCustom) {
                    this.user_utility.errorModelPopup(pipeSpecFlangeMaterial.message);
                }
            }
        });
    }

    ngOnDestroy(): void {
        this.destroy$.next(null);
        this.destroy$.complete();
    }
}
